<template>
  <v-app>
    <div
      v-if="$route.name === 'login' || $route.name === 'register' || $route.name === 'anasirket' || $route.name === 'login-uye' || $route.name ==='uye-detay' || $route.name ==='uye-yeni' || $route.name === 'login-yetkigrup' || $route.name === 'login-yetkigruplist' || $route.name === 'confirm'">
      <router-view></router-view>
    </div>
    <div v-else>

      <v-navigation-drawer persistent :mini-variant="miniVariant" width="245" :clipped="clipped" v-model="drawer"
        enable-resize-watcher fixed="" app>
        <v-list dense>
          <template v-for="item in items">

            <v-list-group v-if="item.items" :key="item.title" :prepend-icon="item.icon" no-action>
              <v-list-tile slot="activator">
                <v-list-tile-content>
                  <v-list-tile-title> {{ item.title }}</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
              <template v-for="(subItem, i) in item.items">
                <!--sub group-->
                <v-list-group v-if="subItem.items" :group="subItem.group" :sub-group="true" :key="subItem.title">
                  <v-list-tile slot="activator" ripple="ripple">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <template v-for="(grand, i) in subItem.items" ripple="ripple">
                    <v-list-group v-if="grand.items" :group="grand.group" :sub-group="true" :key="grand.title">
                      <v-list-tile slot="activator" ripple="ripple">
                        <v-list-tile-content>
                          <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <template v-for="(gsub, i) in grand.items" ripple="ripple">
                        <v-list-tile :key="i" :to="{ name: gsub.to }">
                          <v-list-tile-content>
                            <v-list-tile-title>{{ gsub.title }}</v-list-tile-title>
                          </v-list-tile-content>
                        </v-list-tile>
                      </template>
                    </v-list-group>
                    <!--child item-->
                    <v-list-tile v-else :key="i" :to="{ name: grand.to }">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ grand.title }}</v-list-tile-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list-group>

                <!--child item-->
                <v-list-tile v-else :key="i" :disabled="subItem.disabled" :target="subItem.target" ripple="ripple"
                  :to="{ name: subItem.to }">
                  <v-list-tile-content>
                    <v-list-tile-title>
                      <span>{{ subItem.title }}</span>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-chip class="white--text pa-0 chip--x-small" v-if="subItem.badge" color="primary"
                    disabled="disabled">{{
                    subItem.badge }}</v-chip>
                  <v-list-tile-action v-if="subItem.action">
                    <v-icon :class="[subItem.actionClass || 'success--text']">{{ subItem.action }}</v-icon>
                  </v-list-tile-action>
                </v-list-tile>
              </template>
            </v-list-group>

            <v-list-tile v-else :key="item.title" :to="!item.href ? { name: item.to } : null" :href="item.href">
              <v-list-tile-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title>
                  {{ item.title }}
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>

          </template>
        </v-list>
      </v-navigation-drawer>



      <v-toolbar app :clipped-left="clipped" fixed dense>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <!-- <a href="/" class="d-flex ml-3 router-link-active">
          <img src="./assets/images/arkman_avatar.png">
        </a> -->
        <a href="/" class="d-flex ml-3 router-link-active">
          <img src="./assets/images/arkman_nav.png">
        </a>
        <v-spacer></v-spacer>

        <v-toolbar-items>




          <!-- <v-menu bottom left offset-y>
            <v-btn @click="sirketgetir()" flat slot="activator">
              <span>{{ Sirket.SirketAdi }}</span>
              <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile v-for="item in Sirketler1" :key="item.text" @click="sirketdegistir(item)">
                <v-list-tile-title>{{ item.SirketAdi }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu> -->
          <!-- <v-btn icon @click="logout">
            <v-icon>power_settings_new</v-icon>
          </v-btn> -->

          <v-menu v-model="menu" :close-on-content-click="false" :nudge-width="100" left>

            <template slot="activator">
              <v-avatar size="32px">
                <img src="https://randomuser.me/api/portraits/lego/2.jpg">
              </v-avatar>

            </template>

            <v-card>
              <v-list>
                <v-card flat color="grey lighten-4">
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-icon>settings
                      </v-icon>

                    </v-list-tile-action>
                    <v-list-tile-title>{{aktifkullanici}}</v-list-tile-title>
                  </v-list-tile>
                </v-card>
              </v-list>

              <v-divider></v-divider>

              <v-list>


                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon>language</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-sub-title>
                    <v-layout justify-center align-start="">
                      <!-- <v-menu offset-y>
                        <v-btn slot="activator" flat="">
                          <img v-if="this.locale=='tr'" style="height:32px; width:32px;" src="./assets/images/turkey.png">
                          <img v-if="this.locale=='en'" style="height:32px; width:32px;" src="./assets/images/english.png">
                          <img v-if="this.locale=='de'" style="height:32px; width:32px;" src="./assets/images/germany.png">

                        </v-btn>
                        <v-list>
                          <v-list-tile v-for="(locale, index) in locales" :key="index" @click="switchLocale(index)">
                            <v-list-tile>
                              <v-list-tile-avatar @click="changeLanguage(locale.locale)">
                                <img v-bind:src="locale.href" width="24px">
                                <img style="height:32px; width:32px;" :src="getImgUrl(locale.href)">
                              </v-list-tile-avatar>
                              <v-list-tile-title>
                                {{ locale.title }}
                              </v-list-tile-title>
                            </v-list-tile>
                          </v-list-tile>
                        </v-list>
                      </v-menu> -->
                      <v-select solo :items="locales" hide-details="" v-model="locale" item-text="title"
                        @change="changeLanguage(locale)" item-value="locale"></v-select>
                    </v-layout>

                  </v-list-tile-sub-title>
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile @click="logout()">
                  <v-list-tile-action>
                    <v-icon>power_settings_new</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-title> &nbsp;Çıkış Yap</v-list-tile-title>
                </v-list-tile>
              </v-list>


            </v-card>
          </v-menu>



        </v-toolbar-items>


      </v-toolbar>

      <v-content>
        <router-view></router-view>
      </v-content>

      <v-footer :fixed="fixed" app>
        <span>&copy; 2020 Arkman Bilgisayar Tek. ve Yaz. Ltd. </span>
      </v-footer>

      <v-dialog v-model="dialog" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Uyarı!</v-card-title>
          <v-card-text> Şirket değişimi yapmak istiyor musunuz?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="info" flat="flat" @click.native="dialog = false">İptal</v-btn>
            <v-btn color="info" flat @click.native="degistir()">Tamam</v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>
  </v-app>
</template>

<script>
  import TheLanguageSwitcher from '@/components/TheLanguageSwitcher'


  import auth from '../src/api/auth'
  import router from './router'
  import _ from 'underscore'
  import $ from '@/plugins/i18n.js'
  import {
    Trans
  } from '@/plugins/Translation'

  export default {
    data() {
      return {
        aktifkullanici: null,
        on: false,
        fav: true,
        menu: false,
        message: false,
        hints: true,
        locale: 'tr',
        locales: [{
            locale: 'tr',
            title: 'Türkçe',
            href: 'turkey'
          },
          {
            locale: 'en',
            title: 'English',
            href: 'english'
          },
          {
            locale: 'de',
            title: 'Deutsch',
            href: 'germany'
          },
        ],

        clipped: true,
        drawer: true,
        fixed: false,
        miniVariant: false,
        right: true,
        rightDrawer: false,
        title: 'Arkman',


        items: [{
            icon: 'home',
            title: 'Ana Sayfa',
            to: 'home',
            href: '/#/'
          },
          {
            icon: 'attach_money',
            title: 'Cari Hesap',
            group: 'musteri',
            color: 'blue darken-2',
            items: [{
                title: 'Ekstre Listesi',
                to: 'dot9-ekstrelistesi',
                href: '/#/musteri/index'
              }
              //{
              //   title: 'Fatura Listesi',
              //   to: 'dot9-faturalistesi',
              //   href: '/#/musteri/index'
              // }
            ]

          }, {
            icon: 'flight_takeoff',
            title: 'Bilet',
            group: 'musteri',
            color: 'blue darken-2',
            items: [{
              title: 'Bilet Raporu',
              to: 'dot9-biletraporu',
              href: '/#/bilet/biletraporu'
            }, {
              title: 'Uçuş Raporu',
              to: 'dot9-ucusraporu',
              href: '/#/bilet/ucusraporu'
            }, {
              title: 'En Çok Gidilen Yerler',
              to: 'dot9-encokgidilenyerler',
            }, {
              title: 'Class Raporu',
              to: 'dot9-classraporu',
            }, {
              title: 'Detaylı Booking Raporu',
              to: 'dot9-detaylibooking',
            }, {
              title: 'Segment Raporu',
              to: 'dot9-segmentraporu',
            }, {
              title: 'Summary Rapor',
              to: 'dot9-summaryrapor',
            },{
              title: 'Genel Amaçlı Rapor',
              to:'bilet-genelamacliraporu'
            }
            ]

          },
          {
            icon: 'style',
            title: 'Vize Raporları',
            group: 'vize',
            color: 'blue darken-2',
            items: [{
                title: 'Vize Raporları',
                to: 'dot9-vizeraporu',
                href: '/#/vize/vizeraporu'
              }
              // ,{
              //   title: 'Vize Ara',
              //   to: 'musteri-listesi',
              //   href: '/#/musteri/index'
              // }
            ]

          },
          {
            icon: 'business',
            title: 'Firma Bilgileriniz',
            to: 'dot9-firmabilgileri',
            href: '/#/firma/firmabilgileri'
          },
          {
                    icon: 'today',
                    title: 'Takvim',
                    to: 'takvim',
                    href: '/#/takvimv2/takvim'
                },
        ],



        Sirket: {
          SirketUnvani: '',
          SirketKodu: '',
          SirketAdi: '',
          AnaSirketKodu: ''
        },
        Sirketler: [],
        Sirketler1: [],


        dialog: false,
        yedek: {
          aa: '',
          bb: '',
          cc: ''
        }
      }

    },

    computed: {
      supportedLanguages() {
        return Trans.supportedLanguages
      },
      currentLanguage() {
        return Trans.currentLanguage
      }
    },
    beforeMount: beforeMount,
    watch: {

    },
    methods: {
      kullaniciyagit() {
        var manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

        var url = '#/uye/detay/' + manageload.UserInfo.Email
        window.open(url, '_self')
      },
      anasirketleregit() {
        router.push('anasirket')
      },

      sirketgetir() {
        this.Sirketler1 = this.Sirketler

      },
      changeLanguage(e) {
        const lang = e
        const to = this.$router.resolve({
          params: {
            lang
          }
        })
        return Trans.changeLanguage(lang).then(() => {
          this.$router.push(to.location)
          this.locale = e
        })
      },
      isCurrentLanguage(lang) {
        return lang === this.currentLanguage
      },

      getImgUrl(pet) {
        var images = require.context('./assets/images', false, /\.png$/)
        return images('./' + pet + ".png")
      },
      switchLocale: function (index) {
        // $vuetify.locales
        // console.log('switch locale: ', this.locales[index].title)
        // this.locale = this.locales[index].locale
      },
      getChildTarget(item, subItem) {
        if (subItem.href) return
        if (item.component) {
          return {
            name: item.component,
            params: {
              section: item.group,
              component: subItem.name
            }
          }
        }
        return {
          name: `${item.group}/${subItem.name}`
        }
      },
      logout() {
        auth.logout()
      },

      sirketdegistir: sirketdegistir,
      degistir: degistir
    },
    components: {
      'TheLanguageSwitcher': TheLanguageSwitcher
    },
    beforeUpdate: beforeUpdate,
    mounted: beforeUpdate,
    name: 'App'
  }


  function sirketdegistir(item) {
    if (this.Sirket.SirketKodu != item.SirketKodu) {
      this.dialog = true
      this.yedek.aa = item.SirketKodu
      this.yedek.bb = item.SirketAdi
      this.yedek.cc = item.SirketUnvani
    }
  }


  function degistir() {
    var credentials1 = JSON.parse(window.localStorage.getItem('credentials'));

    this.dialog = false

    var credentials = {
      AnaSirketKodu: this.Sirket.AnaSirketKodu,
      SirketKodu: this.yedek.aa,
      SirketAdi: this.yedek.bb,
      SirketUnvani: this.yedek.cc,
      Sirketler: credentials1.Sirketler,
      EArsiv: credentials1.EArsiv,
      EFatura: credentials1.EFatura
    }

    window.localStorage.setItem('credentials', JSON.stringify(credentials));

    router.push({
      path: '/'
    })

  }

  function beforeMount() {}


  function beforeUpdate() {


    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    console.log(credentials)

    if (credentials != undefined && credentials != null) {

      if (credentials.CariBilgi != null) {
        this.aktifkullanici = credentials.CariBilgi.Unvan
      }

    }
  }
</script>

<style lang="stylus">
  @import '../node_modules/vuetify/src/stylus/main.styl';
</style>